/**
 * package: com.inq.flash.messagingframework
 * class: Participant
 * root Object
 * @constructor
 */
com.inq.flash.messagingframework.Participant = function(type,id,username) {
	this.participantType = type;
	this.ID = id;
	this.username = username;
};
$hxClasses['com.inq.flash.messagingframework.Participant'] = com.inq.flash.messagingframework.Participant;
/** @private @type {Array} */
com.inq.flash.messagingframework.Participant.__name__ = ["com","inq","flash","messagingframework","Participant"];

/**
 * getType
 *
 * $type TFun([],TInst(String,[]))
 * public function getType():String
 * @public
 * @this com.inq.flash.messagingframework.Participant
 * @return {string}
 */
com.inq.flash.messagingframework.Participant.prototype.getType = function() {
	return this.participantType;
};


/**
 * getUsername
 *
 * $type TFun([],TInst(String,[]))
 * public function getUsername():String
 * @public
 * @this com.inq.flash.messagingframework.Participant
 * @return {string}
 */
com.inq.flash.messagingframework.Participant.prototype.getUsername = function() {
	return this.username;
};


/**
 * getID
 *
 * $type TFun([],TInst(String,[]))
 * public function getID():String
 * @public
 * @this com.inq.flash.messagingframework.Participant
 * @return {string}
 */
com.inq.flash.messagingframework.Participant.prototype.getID = function() {
	return this.ID;
};

/** @private @type {string} */
com.inq.flash.messagingframework.Participant.prototype.username = null;
/** @private @type {string} */
com.inq.flash.messagingframework.Participant.prototype.participantType = null;
/** @private @type {string} */
com.inq.flash.messagingframework.Participant.prototype.ID = null;
/** @type {com.inq.flash.messagingframework.Participant} */
com.inq.flash.messagingframework.Participant.prototype.__class__ = com.inq.flash.messagingframework.Participant;
